import { I } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RouterLinkWithHref } from '@angular/router';
import {Icon, DomEvent, Map, LeafletEvent, LayerGroup, MapOptions, tileLayer, LatLng, latLng, Marker , MarkerClusterGroup, MarkerClusterGroupOptions, divIcon, ZoomAnimEvent, FullscreenOptions, Control, DomUtil, control, marker } from 'leaflet';
import * as moment from 'moment';
import { DeviceEvent } from 'src/app/data/model/device-event';
import { mapURL } from 'src/environments/environment.api';

@Component({
  standalone: false,
  selector: 'app-smart-bin-map-dialog',
  templateUrl: './smart-bin-map-dialog.component.html',
  styleUrls: ['./smart-bin-map-dialog.component.scss']
})
export class SmartBinMapDialogComponent {
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

  @Output() map$: EventEmitter<Map>= new EventEmitter;
  @Output() zoom$: EventEmitter<number>=new EventEmitter;
  zoom!:number;
  public map!: Map;

  marker_icon =  Icon.extend({
    options:
      {
        iconSize: [31, 31], // size of the icon
        iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/smartbin_green.png'
      }
  })

  getCoords():LatLng {

      /*console.log(this.data.coords)
      var coord = String(this.data.coords).split(" ");
      const mark= coord[0].split("(");
      const mark1= mark[1].split(",");
      const mark2= coord[1].split(")");
      const x= mark2[0] as unknown
      const y= mark1[0] as unknown
      var coords = new LatLng(x as number, y as number)
      return coords*/
    if(this.data.coords !== null){
        var coord = this.data.coords.split(" ");
        const mark1= coord[1].split("(");
        const mark2= coord[2].split(")");
        const x=Number(mark2[0]) as number
        const y= Number(mark1[1]) as number
        var coords = new LatLng(x as number, y as number)
        return coords
      }
    return new LatLng(45.800084381319905, 13.38134765625)
  }
  mapUrl = mapURL.mapUrl !== '${mapURL}' ? mapURL.mapUrl : mapURL.defaultMapUrl;
  @Input() options: MapOptions= {
      layers:[tileLayer(`${this.mapUrl}/styles/m2openmaptiles/{z}/{x}/{y}.png`, {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    })],
    zoom:17,
    center:latLng(this.getCoords()),
  };

  getState(state:DeviceEvent[]){
    if(state.length === 0){
      return '<i style="color: #27f211; padding-left: 1%;" class="fa fa-circle" aria-hidden="true"></i>'
    } if(state[0].is_alarm === false) { 
      return '<i style="color: #f98f04; padding-left: 1%;" class="fa fa-square" aria-hidden="true"></i>' 
    } if(state[0].is_alarm === true) { 
      return '<i style="color: #f00909; padding-left: 1%;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>' 
    } else {
      return ''
    }
  }

  setFilling(filling:number){
    if (filling<5 ){
      return 0
    }
    return filling
  }

  setPopupData() {
    /*const types=[2, 3]
    if(types.includes(this.data.type)) {
      return "<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Tipologia Rifiuto: "+this.data.bin_item?.type_item?.waste_type+"</td></tr><tr><td><b/>Seriale Contenitore: "+this.data.bin_item?.name+"</td></tr></table><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Stato: "+this.getState(this.data.state)+"</td></tr><tr><td><b/>% Riempimento:"+this.setFilling(this.data.filling_level)+"</td></tr></table></div>";
    }*/
    if(this.data.type==2){
      return "<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Tipologia Rifiuto: "+this.data.bin_item?.type_item?.waste_type+"</td></tr><tr><td><b/>Seriale Contenitore: "+this.data.bin_item?.name+"</td></tr></table><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Stato: "+this.getState(this.data.state)+"</td></tr><tr><td><b/>% Riempimento:"+this.setFilling(this.data.filling_level)+"</td></tr></table></div>";
    } else if(this.data.type==3){
      return "<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Tipologia Rifiuto: "+this.data.bin_item?.type_item?.waste_type+"</td></tr><tr><td><b/>Seriale Contenitore: "+this.data.bin_item?.name+"</td></tr></table><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>% Riempimento:"+this.setFilling(this.data.filling_level)+"</td></tr></table></div>";
    } else {
      return "<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Tipologia Rifiuto: "+this.data.bin_item?.type_item?.waste_type+"</td></tr><tr><td><b/>Seriale Contenitore: "+this.data.bin_item?.name+"</td></tr></table><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Stato: "+this.getState(this.data.state)+"</td></tr><tr><td><b/>Numero Conferimenti:"+this.data.conferral_number+"</td></tr><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Data Svuotamento:"+moment(this.data.emptying_date).format('DD/MM/yyyy, HH:mm:ss')+"</td></tr></table></div>";
    }
  }

  onMapReady(map: Map) {
      this.map = map;
      this.map$.emit(map);
      this.zoom = map.getZoom();
      this.zoom$.emit(this.zoom);
      var popup_data:string
      popup_data = this.setPopupData();
      marker(this.getCoords(), {icon:new this.marker_icon}).bindPopup(popup_data, {closeButton: false}).addTo(map);
    }

  onMapZoomEnd(e: LeafletEvent) {
    this.zoom = e.target.getZoom();
    this.zoom$.emit(this.zoom);
  }
}

export type DialogMapParams = {
data: any;
};

